import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {tpsltsOrders$, airdropPosTpsltsOrders$} from './tpslts';
import {TpsltsRecord} from '@/types';

export interface UTpslCache {
  type: 'tpsltsCache';
  data: Map<string, TpsltsRecord>;
}

export interface UAirdropPositionTpslCache {
  type: 'airdrop-pos-tpslts-cache';
  data: Map<number, TpsltsRecord>;
}

export function subscribeTpsl() {
  tpsltsOrders$.pipe(map((data) => ({type: 'tpsltsCache' as const, data}))).subscribe((msg) => toUiMsg$.next(msg));

  airdropPosTpsltsOrders$
    .pipe(map((data) => ({type: 'airdrop-pos-tpslts-cache' as const, data})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
